import {createApiServices} from '@pf126/api-maker'

export default createApiServices({
    baseUrl: process.env.NODE_ENV === 'production' ? '/api/labels' : process.env.REACT_APP_API_URL
})
